// extracted by mini-css-extract-plugin
export default {"wrapper":"FormItemError_wrapper__fmDdI","left":"FormItemError_left__9dFLG","right":"FormItemError_right__S-jCN"};